module.exports = {"id":"146296","name":"Andrés Fernández","rating":"76","photo":"./data/images/photos/3/146296.png","club":{"name":"Villarreal CF","logo":"./data/images/clubs/VillarrealCF.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndresFernandez0.json
// module id = 390
// module chunks = 0